import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"consultant-select","item-text":"nome","item-name":"usuarioId","item-value":"usuarioId","items":_vm.users,"label":_vm.consultorLabel,"placeholder":_vm.consultorLabel,"clearable":""},model:{value:(_vm.filter.usuarioId),callback:function ($$v) {_vm.$set(_vm.filter, "usuarioId", $$v)},expression:"filter.usuarioId"}},[_c('template',{slot:"no-data"},[_vm._v(" Nenhum usuário retornado ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }